"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = _interopRequireDefault(require("../../Button/index"));

var _palette = require("../../../../styles/palette");

var _icons = require("../../../../static/icons/icons");

var _style = require("./style");

var _lang = _interopRequireDefault(require("./lang"));

var _useCalendar2 = _interopRequireDefault(require("./useCalendar"));

var InputDateComponent = function InputDateComponent(_ref) {
  var value = _ref.value,
      _ref$language = _ref.language,
      language = _ref$language === void 0 ? 'en' : _ref$language,
      min = _ref.min,
      label = _ref.label,
      id = _ref.id,
      helper = _ref.helper,
      icon = _ref.icon,
      error = _ref.error,
      handleSelect = _ref.handleSelect,
      handleChange = _ref.handleChange,
      handleFocus = _ref.handleFocus;

  var _useCalendar = (0, _useCalendar2["default"])({
    value: value,
    language: language,
    min: min,
    handleSelect: handleSelect,
    handleChange: handleChange,
    handleFocus: handleFocus
  }),
      active = _useCalendar.active,
      dirty = _useCalendar.dirty,
      currentValue = _useCalendar.currentValue,
      weekItems = _useCalendar.weekItems,
      calendarItems = _useCalendar.calendarItems,
      onChange = _useCalendar.onChange,
      onFocus = _useCalendar.onFocus,
      isNotFirstDayOfMonth = _useCalendar.isNotFirstDayOfMonth,
      goToPrevMonth = _useCalendar.goToPrevMonth,
      goToNextMonth = _useCalendar.goToNextMonth,
      currentStatus = _useCalendar.currentStatus,
      monthTitle = _useCalendar.monthTitle,
      setToday = _useCalendar.setToday,
      onAccept = _useCalendar.onAccept,
      toggleActive = _useCalendar.toggleActive;

  var calendarOnClick = function calendarOnClick(e) {
    e.stopPropagation();
  };

  var weekContent = weekItems.map(function (item) {
    return _react["default"].createElement(_style.WeekDay, {
      key: item.key,
      className: "notranslate"
    }, item.label);
  });
  var calendarContent = calendarItems.map(function (item) {
    return item.type === 'br' ? _react["default"].createElement("br", {
      key: item.key
    }) : _react["default"].createElement(_style.Day, {
      "data-test-id": "calendarDay",
      className: "notranslate",
      disabled: item.disabled,
      current: item.current,
      onClick: item.onClick,
      key: item.key,
      nextMonth: item.nextMonth
    }, item.label);
  });
  return _react["default"].createElement(_style.InputContainer, {
    "data-error": error,
    icon: icon,
    active: active,
    dirty: dirty
  }, _react["default"].createElement("label", {
    htmlFor: id
  }, label), _react["default"].createElement("input", {
    onChange: onChange,
    readOnly: true,
    type: "text",
    id: id,
    value: currentValue,
    onFocus: onFocus,
    autoComplete: "off"
  }), _react["default"].createElement("span", null, helper), icon && _react["default"].createElement(_style.StyledIcon, {
    icon: _icons.ICONS.CALENDAR,
    size: 24,
    color: error ? _palette.palette.error : currentStatus.color
  }), active && _react["default"].createElement(_style.Overlay, {
    onClick: toggleActive
  }, _react["default"].createElement(_style.Calendar, {
    onClick: calendarOnClick
  }, _react["default"].createElement(_style.Title, {
    className: "notranslate"
  }, isNotFirstDayOfMonth ? _react["default"].createElement(_style.Arrow, {
    icon: _icons.ICONS.LEFT,
    size: 16,
    handleClick: goToPrevMonth,
    testId: "previousMonth"
  }) : _react["default"].createElement("div", null), monthTitle, _react["default"].createElement(_style.Arrow, {
    icon: _icons.ICONS.RIGHT,
    size: 16,
    handleClick: goToNextMonth,
    testId: "nextMonth"
  })), _react["default"].createElement(_style.Week, {
    className: "notranslate"
  }, weekContent), _react["default"].createElement(_style.WeekDaysContainer, null, calendarContent), _react["default"].createElement(_style.Close, null, _react["default"].createElement(_index["default"], {
    text: _lang["default"][language].today,
    handleClick: setToday,
    reverse: true
  }), _react["default"].createElement(_index["default"], {
    text: _lang["default"][language].accept,
    handleClick: onAccept,
    id: "calendarAcceptButton"
  })))));
};

InputDateComponent.propTypes = {
  id: _propTypes["default"].string,
  label: _propTypes["default"].string,
  helper: _propTypes["default"].string,
  icon: _propTypes["default"].bool,
  language: _propTypes["default"].string,
  error: _propTypes["default"].bool,
  handleFocus: _propTypes["default"].func,
  handleSelect: _propTypes["default"].func,
  handleChange: _propTypes["default"].func,
  min: _propTypes["default"].string,
  value: _propTypes["default"].string
};
InputDateComponent.defaultProps = {
  id: 'inputText',
  label: 'label',
  helper: undefined,
  icon: undefined,
  error: false,
  handleFocus: undefined,
  language: 'en',
  handleSelect: function handleSelect(value) {
    console.log('value =>', value);
  },
  handleChange: undefined,
  min: (0, _moment["default"])().format('YYYY-MM-DD'),
  value: undefined
};
var _default = InputDateComponent;
exports["default"] = _default;